enum CyclePhase {
  PreLending = 'PRE_LENDING',
  ActivelyLending = 'ACTIVELY_LENDING',
  PostLending = 'POST_LENDING',
  None = 'NONE',
}

export default CyclePhase;
